export const SYDON_API_URL =
  process.env.REACT_APP_SYDON_API_URL ?? 'https://hetzner-sydon-api.sydon.ai';
export const AUTH_URL = process.env.REACT_APP_AUTH_URL ?? 'https://auth.sydon.ai';
export const STAC_DASHBOARD_URL =
  process.env.REACT_APP_STAC_DASHBOARD_URL ?? window.location.origin;

// Local dev only: set REACT_APP_SKIP_AUTH=true in a gitignored .env.local to
// bypass PropelAuth/sydon-api and view the dashboard shell with a mock user.
// Never set in a committed .env or in any deployed environment.
export const SKIP_AUTH = process.env.REACT_APP_SKIP_AUTH === 'true';
